module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mmsbnp4-fcefb83cc9daa3ba2063f88afcd0d5d8.jpg";